var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompletedItemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Completed_Item_Icon",
    "data-name": "Completed Item Icon",
    transform: "translate(-1513 -470)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1513 470)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check_circle_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M90.32-862.48l8.46-8.46-1.68-1.68-6.78,6.78-3.42-3.42-1.68,1.68ZM92-856a11.686,11.686,0,0,1-4.68-.945,12.118,12.118,0,0,1-3.81-2.565,12.118,12.118,0,0,1-2.565-3.81A11.685,11.685,0,0,1,80-868a11.685,11.685,0,0,1,.945-4.68,12.118,12.118,0,0,1,2.565-3.81,12.117,12.117,0,0,1,3.81-2.565A11.685,11.685,0,0,1,92-880a11.685,11.685,0,0,1,4.68.945,12.117,12.117,0,0,1,3.81,2.565,12.118,12.118,0,0,1,2.565,3.81A11.685,11.685,0,0,1,104-868a11.685,11.685,0,0,1-.945,4.68,12.118,12.118,0,0,1-2.565,3.81,12.118,12.118,0,0,1-3.81,2.565A11.686,11.686,0,0,1,92-856Z",
    transform: "translate(1433 1350)",
    fill: "#4cc681"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedItemIcon);
export default __webpack_public_path__ + "static/media/Completed Item Icon.afc9619185ac031a84dcbd1ba9c8116a.svg";
export { ForwardRef as ReactComponent };